module.exports = __webpack_public_path__ + "media/images/matrimony_uk-26c3b4ccc619bf5d96da3454e73a82aa.jpg";